import React, { useState } from "react";
import { motion } from "framer-motion";

const LanguageSlider = () => {
  const [isPaused, setIsPaused] = useState(false);

  const languages = [
    "FRENCH",
    "GERMAN",
    "ARABIC",
    "ITALIAN",
    "SPANISH",
    "ENGLISH",
    "JAPANESE",
    "CHINESE",
    "RUSSIAN",
    "PORTUGUESE",
  ];

  // Duplicate the languages array to create a seamless loop
  const duplicatedLanguages = [...languages, ...languages];

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full h-20 bg-[#a1a1a1] py-6 overflow-hidden relative"
    >
      {/* Left blur gradient */}
      <div className="absolute left-0 top-0 h-full w-36 bg-gradient-to-r from-[#a1a1a1] to-transparent z-10"></div>

      <div
        className="w-full overflow-hidden whitespace-nowrap"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <motion.div
          className="inline-flex space-x-6 md:space-x-8 text-xl font-bold text-white items-center"
          animate={{
            x: isPaused ? 0 : "-50%"
          }}
          transition={{
            x: {
              duration: 20,
              ease: "linear",
              repeat: Infinity,
              repeatType: "loop",
              repeatDelay: 0,
              paused: isPaused
            }
          }}
        >
          {duplicatedLanguages.map((language, index) => (
            <React.Fragment key={index}>
              <motion.div 
                className="inline-block cursor-pointer hover:text-accent transition-colors duration-300"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                {language}
              </motion.div>
              {index < duplicatedLanguages.length - 1 && (
                <span className="inline-block text-white/70"> • </span>
              )}
            </React.Fragment>
          ))}
        </motion.div>
      </div>

      {/* Right blur gradient */}
      <div className="absolute right-0 top-0 h-full w-36 bg-gradient-to-l from-[#a1a1a1] to-transparent z-10"></div>
    </motion.div>
  );
};

export default LanguageSlider;
